<template>
  <div class="bd-main form-center">
    <div class="dialog-container dialog-light">
      <div class="dialog dialog-md">
        <ax-dialog-header text="My Profile" :type="'profile'"></ax-dialog-header>
        <div class="dialog-body">
          <div class="ax-form-center">
            <k-form @submit.stop.prevent="updateProfile">
              <div class="form-group">
                  <k-input
                    type="text"
                    v-model="firstName"
                    :label="'First name*'"
                    placeholder="First name"
                    ref="firstNameInput"
                    v-kendo-validator="validateFirstName()"/>
              </div>
              <div class="form-group">
                <k-input
                  type="text"
                  v-model="lastName"
                  :label="'Last name*'"
                  placeholder="Last Name"
                  ref="lastNameInput"
                  v-kendo-validator="validateLastName()"/>
              </div>
              <div class="form-group">
                <k-input
                  type="text"
                  v-model="email"
                  :label="'Email*'"
                  placeholder="Email"
                  :disabled="true"
                  :readonly="true" />
              </div>
              <div class="form-group">
                <k-masked-textbox
                  :mask="maskMobilePhone"
                  label="Mobile number"
                  v-model="phone"
                  ref="phoneInput"
                  v-kendo-validator="validatePhone()"
                  @click="disableReadonlyMode"
                  @focus="disableReadonlyMode"
                ></k-masked-textbox>
              </div>
              <div v-if="!this.isXeroUser">
              <h2 class="mt-5">Password</h2>
              <div class="form-group">
                <k-input
                  type="password"
                  v-model="password"
                  :label="'New Password'"
                  placeholder="New Password"
                  ref="passwordInput"
                  v-kendo-validator="validatePassword()"/>
              </div>
              <div class="form-group">
                <k-input
                  type="password"
                  ref="confirmPassword"
                  v-model="confirmPassword"
                  :label="'Confirm Password'"
                  placeholder="Confirm Password"
                  v-kendo-validator="validateConfirmPassword()"/>
              </div>
              </div>
              <div class="mt-5">
                <k-button
                  class="btn btn-lg btn-secondary w-100 save mb-2"
                  type="submit"
                  @click="updateProfile"
                >Save</k-button>
                <k-button
                  class="btn btn-lg btn-outline-primary w-100"
                  type="submit"
                  @click="$emit('closePopup')"
                >Cancel</k-button>
              </div>
            </k-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import kendo from "@progress/kendo-ui";
import UserManagementService from "../../services/user-management-service";
import store from "../../store";
import { useToast } from "vue-toastification";
import { passwordRegex } from "../../utils/validation-patterns";

const toast = useToast();
const specialCharacterRegex = /[!@#$%^&*()_+=[\]{};:"\\|,.<>/?]+/;
const numberRegex = /\d/;
const phoneRegex = /^(\+?\(61\)|\(\+?61\)|\+?61|\(04[0-9]\)|04[0-9])?( ?-?[0-9]){7,9}$/;

export default {
  name: "profile-dialog",
  data() {
    return {
      userID: "",
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      isXeroUser: false,
      maskMobilePhone: "0000000000",
      invalidFirstName: false,
      invalidLastName: false,
      invalidPhone: false,
      password: "",
      confirmPassword: "",
      invalidPassword: false,
      invalidConfirmPassword: false
    }
  },
  async mounted() {
    await this.initialLoad();
  },
  watch: {
    phone: function() {
      if (this.phone !== "") {
        const phoneNumber = this.phone.split("");
        let dashCount = 0;
        phoneNumber.forEach((number) =>
          number === "_" ? (dashCount += 1) : dashCount
        );
        if (dashCount === 10) {
          this.phone = "";
        }
      }
    }
  },
  computed: {
    anyInvalid: function() {
      if (this.password !== "" || this.confirmPassword !== "") {
        return this.invalidFirstName || this.invalidLastName || this.invalidPhone || this.invalidPassword || this.invalidConfirmPassword;
      }
      else {
        return this.invalidFirstName || this.invalidLastName || this.invalidPhone;
      }
    }
  },
  methods: {
    async initialLoad() {
      const response = await UserManagementService.getCurrentUserProfile();
      const profile = response.data;
      this.userID = profile.userID;
      this.firstName = profile.firstName;
      this.lastName = profile.lastName;
      this.email = profile.email;
      this.phone = profile.phone;
      this.isXeroUser = profile.isXeroUser;
    },
    validateFirstName: function () {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const vm = this;
      return {
        rules: {
          invalid: function () {
            if (vm.firstName.trim() !== "") {
              if (vm.firstName.split("").length === 1) {
                vm.invalidFirstName = true;
                return false;
              }
              else {
                const checkSpecialCharacter = specialCharacterRegex.test(vm.firstName);
                const checkContainNumber = numberRegex.test(vm.firstName);
                vm.invalidFirstName = checkSpecialCharacter || checkContainNumber;
                return !(checkSpecialCharacter || checkContainNumber);
              }
            }
            vm.invalidFirstName = true;
            return false;
          },
          required: function () {
            if (vm.firstName === "") {
              vm.invalidFirstName = true;
              return false;
            }
            vm.invalidFirstName = false;
            return true;
          }
        },
        messages: {
          invalid: "Invalid",
          required: "Required"
        }
      }
    },
    validateLastName: function() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const vm = this;
      return {
        rules: {
          invalid: function() {
            if (vm.lastName.trim() !== "") {
              if (vm.lastName.split("").length === 1) {
                vm.invalidLastName = true;
                return false;
              }
              else {
                const checkSpecialCharacter = specialCharacterRegex.test(vm.lastName);
                const checkContainNumber = numberRegex.test(vm.lastName);
                vm.invalidLastName = checkSpecialCharacter || checkContainNumber;
                return !(checkSpecialCharacter || checkContainNumber);
              }
            }
            vm.invalidLastName = true;
            return false;
          },
          required: function () {
            if (vm.lastName === "") {
              vm.invalidLastName = true;
              return false;
            }
            vm.invalidLastName = false;
            return true;
          }
        },
        messages: {
          invalid: "Invalid",
          required: "Required"
        }
      }
    },
    validatePhone: function() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const vm = this;
      return {
        rules: {
          invalid: function() {
            let phoneIsEmpty = true;
            const phoneArray = vm.phone.split("");
            let countDashInPhone = 0;
            phoneArray.forEach((number) =>
              number === "_" ? (countDashInPhone += 1) : countDashInPhone
            );
            if (countDashInPhone === 10) {
              phoneIsEmpty = true;
            }
            else {
              phoneIsEmpty = false;
            }

            if (vm.phone !== "") {
              if (!phoneIsEmpty) {
                const checkPhone = phoneRegex.test(vm.phone);
                vm.invalidPhone = !checkPhone;
                return checkPhone;
              }
            }
            vm.invalidPhone = false;
            return true;
          }
        },
        messages: {
          invalid: "Invalid"
        }
      }
    },
    validatePassword: function() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const vm = this;
      return {
        rules: {
          invalid: function () {
            if (vm.password !== "") {
              const checkPasswordStrength = passwordRegex.test(vm.password);
              //cross check with confirm password
              if (vm.confirmPassword === "") {
                vm.invalidConfirmPassword = true;
              }
              else {
                const validator = kendo.jQuery(vm.$refs.confirmPassword.$el).getKendoValidator();
                validator.validateInput(kendo.jQuery(vm.$refs.confirmPassword.$el)[0].children[0]);
              }
              vm.invalidPassword = !checkPasswordStrength;
              return checkPasswordStrength;
            }
            vm.invalidPassword = false;
            return true;
          }
        },
        messages: {
          invalid: "Invalid"
        }
      }
    },
    validateConfirmPassword: function() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const vm = this;
      return {
        rules: {
          notMatching: function () {
            if (vm.confirmPassword !== "") {
              if (vm.password !== vm.confirmPassword) {
                vm.invalidConfirmPassword = true;
                return false;
              }
            }
            vm.invalidConfirmPassword = false;
            return true;
          },
          required: function () {
            if (vm.confirmPassword === "" && vm.password !== "") {
              vm.invalidConfirmPassword = true;
                return false;
            }
            vm.invalidConfirmPassword = false;
            return true;
          }
        },
        messages: {
          notMatching: "Not matching",
          required: "Required"
        }
      }
    },
    async updateProfile () {
      if (!this.anyInvalid) {
        this.$emit("closePopup");
        await UserManagementService.updateUser({
            active: true,
            userID: this.userID,
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.email,
            phone: this.phone,
            password: this.password
          })
          .then(() => {
              store.dispatch("loadLoggedInFirstName");
              toast.clear();
              toast.success("Successful");
          })
          .catch((error) => {
            this.showAlert(error.message ? error.message : "Something went wrong, please try again!");     
          });
      } else {
        const controlsToValidate = [
          this.$refs.firstNameInput.$el,
          this.$refs.lastNameInput.$el,
          this.$refs.phoneInput.$el
        ];
        if (this.password !== "" || this.confirmPassword !== "") {
          controlsToValidate.push(this.$refs.passwordInput.$el, this.$refs.confirmPassword.$el);
        }
        controlsToValidate.forEach(control => {
          const validator = kendo.jQuery(control).getKendoValidator();
          var ele = kendo.jQuery(control)[0].children[0].children[0];
          validator.validateInput(ele);
        });
      }
    },
    showAlert(error) {
      toast.clear();
      toast.error(error ? error : "Something went wrong! Please try again.");
    },
    disableReadonlyMode(e) {
      e.target.removeAttribute("readonly");
    },
  }
}
</script>
